"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  // blogs
  BLOGS_FETCH_BLOG: null,
  BLOGS_FETCH_BLOGS: null,
  BLOGS_SAVE_BLOG_CACHE: null,
  BLOGS_CLEAR_CACHE: null,
  // Forms
  FORMS_FETCH_FORM: null,
  FORMS_FETCH: null,
  FORMS_CREATE: null,
  FORMS_CLEAR_CACHE: null,
  FORMS_SAVE_FORM_CACHE: null,
  // workflows
  WORKFLOWS_FETCH_WORKFLOW: null,
  WORKFLOWS_FETCH_WORKFLOWS: null,
  WORKFLOWS_CREATE_WORKFLOW: null,

  /* Workflows do not need cache, no pagination yet */
  // tags
  TAGS_FETCH_TAG: null,
  TAGS_FETCH_TAG_BY_SLUG: null,
  TAGS_FETCH_TAGS: null,
  TAGS_SAVE_TAG_CACHE: null,
  TAGS_CLEAR_CACHE: null,
  // users
  USERS_FETCH_USERS: null,
  USERS_FETCH_USERS_FOR_TEAMS: null,
  USERS_UPDATE_USERS_FOR_TEAMS: null,
  // hubdb
  HUBDB_FETCH_TABLE: null,
  HUBDB_FETCH_TABLES: null,
  HUBDB_SAVE_TABLE_CACHE: null,
  HUBDB_CLEAR_CACHE: null,
  // pages
  PAGES_FETCH_PAGE: null,
  PAGES_FETCH_PAGES: null,
  PAGES_SAVE_PAGE_CACHE: null,
  PAGES_CLEAR_CACHE: null,
  // emails
  EMAILS_FETCH_EMAIL: null,
  EMAILS_FETCH_EMAILS: null,
  EMAILS_SAVE_EMAIL_CACHE: null,
  EMAILS_CLEAR_CACHE: null,
  EMAILS_CREATE_EMAIL: null,
  // menus
  MENUS_CREATE_MENU: null,
  MENUS_FETCH_MENU: null,
  MENUS_FETCH_MENUS: null,
  MENUS_SAVE_MENU_CACHE: null,
  MENUS_CLEAR_CACHE: null,
  // ctas
  CTAS_FETCH_CTA: null,
  CTAS_FETCH_CTAS: null,
  CTAS_SAVE_CTA_CACHE: null,
  CTAS_CLEAR_CACHE: null,
  // meetings
  MEETINGS_FETCH_MEETING: null,
  MEETINGS_FETCH_MEETINGS: null,
  // Salesforce
  SALESFORCE_FETCH_CAMPAIGN: null,
  SALESFORCE_FETCH_CAMPAIGNS: null,
  SALESFORCE_FETCH_INTEGRATION_STATUS: null,
  // Go To Webinar
  GOTOWEBINAR_FETCH_FUTURE_WEBINARS: null,
  GOTOWEBINAR_FETCH_SETTINGS: null,
  GOTOWEBINAR_FETCH_ELIGIBLE_FORMS: null,
  // Fetching icons
  CLEAR_ICONS: null,
  FETCH_ICON: null,
  FETCH_ICONS: null,
  SAVE_ICON: null,
  FETCH_SELECTED_ICONS: null,
  // Domains
  SITE_SETTINGS_FETCH: null,
  // Teams
  TEAMS_FETCH_TEAMS: null,
  TEAMS_UPDATE_TEAMS_DATA: null,
  // Video
  VIDEOS_FETCH_VIDEO: null,
  VIDEOS_SAVE_VIDEO: null,
  // Google fonts;
  GOOGLE_FONTS_FETCH_FONT: null,
  GOOGLE_FONTS_FETCH_FONTS: null,
  GOOGLE_FONTS_CLEAR: null,
  SELECT_GOOGLE_FONT: null,
  GOOGLE_FONTS_FETCH_COMMON_FONTS: null,
  // Field validation
  ADD_FIELD_VALIDATION_ERROR: null,
  REMOVE_FIELD_VALIDATION_ERROR: null,
  SHIFT_FIELD_VALIDATION_ERROR: null,
  // Can spam settings
  CAN_SPAM_SETTINGS_FETCH: null,
  UPDATE_CAN_SPAM_SETTINGS_PENDING: null,
  UPDATE_CAN_SPAM_SETTINGS_SUCCESS: null,
  UPDATE_CAN_SPAM_SETTINGS_FAIL: null
});

exports.default = _default;
module.exports = exports.default;